
<div class="v-flex mt-1 secondary lighten-4" style="height: calc(100% - 55px); margin-right: 70px; overflow: hidden">
    <div style="width: 35%">
        <p-inc-outbox-filter
            :loading = "loading"
            :steps   = "steps"
            @filter  = "onLoad"
            @step    = "onStep"
            @search  = "onSearch"
        />

        <div class="mt-2 ml-3 ">
            <virtual-scroller
                v-if           = "entries"
                :items         = "filteredEntries"
                :min-item-size = "50"
                key-field      = "id"
                :prerender     = "1"
                :style         = "'max-height:' + (height - 60) + 'px'"
                class          = "dialog-border"
                style          = "width: calc(100% + 14px)"
                v-slot         = "{ item }"
            >
                <div class="mr-2">
                    <div v-if="item.date" class="pt-2 pl-1 primary--text mail-header">
                        {{ item.date }}
                    </div>

                    <p-inc-outbox-entry
                        class     = "w-100"
                        :class    = "border(item) + ' ' +((selected && selected.id === item.id) ? 'background-selected' : 'white')"
                        :mail     = "item"
                        @selected = "onSelected"
                    />
                </div>
            </virtual-scroller>
        </div>
    </div>

    <div class="dialog-border mt-3 mr-3 pl-2" style="width: 65%; margin-left: 14px; overflow: hidden"
         :style="'height: ' + (height + 156) + 'px'"
    >
        <p-inc-outbox-mail
            v-if         = "mail"
            :mail        = "mail"
            :height      = "height"
            :incident-id = "selected.incidentId"
            @close       = "onClose"
        />
    </div>
</div>
